import { connect } from "react-redux";

import actions from "../../actions";
import Area from "../../components/master/Area";

const mapStateToProps = (state) => {
  return {
    masterItems: state.area.masterItems,
    text: state.area.text,
    items: state.area.items,
    current: state.area.current,
    fetching: state.area.fetching,
    isError: state.area.isError,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeSearchText: (text) => dispatch(actions.area.changeSearchText(text)),
    fetchItems: (callback) => dispatch(actions.area.fetchItems(callback)),
    searchItems: (text, callback) => dispatch(actions.area.searchItems(text, callback)),
    fetchItem: (id, callback, failedCallback) => dispatch(actions.area.fetchItem(id, callback, failedCallback)),
    createItem: (data, handleSuccess, handleCancel) =>
      dispatch(actions.area.createItem(data, handleSuccess, handleCancel)),
    updateItem: (data, handleSuccess, handleCancel, failedCallback) =>
      dispatch(actions.area.updateItem(data, handleSuccess, handleCancel, failedCallback)),
    deleteItem: (id, name) => dispatch(actions.area.deleteItem(id, name)),
    setUnloadAlert: () => dispatch(actions.app.setUnloadAlert()),
    clearUnloadAlert: () => dispatch(actions.app.clearUnloadAlert()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Area);
